import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useGetPlacementCandidate } from "../../../PlacementCandidate/api/useGetPlacementCandidate";
import { useUpdatePlacementCandidate } from "../../../PlacementCandidate/api/useUpdatePlacementCandidate";
import { isPlacementCandidate } from "../../../PlacementCandidate/types";
import {
  type ApplicationPreferencesFormData,
  WorkerPreferencesStep,
} from "./WorkerPreferencesStep";

interface WorkerPreferencesStepContainerProps {
  applicationQualification: string | undefined;
  placementCandidateId: string;
}

export function WorkerPreferencesStepContainer(props: WorkerPreferencesStepContainerProps) {
  const { applicationQualification, placementCandidateId } = props;

  const worker = useDefinedWorker();

  const { data: placementCandidate } = useGetPlacementCandidate(
    { workerId: worker.userId },
    { enabled: Boolean(worker.userId) }
  );

  const { mutate: updatePlacementCandidate } = useUpdatePlacementCandidate();

  const handleFieldChange = (
    fieldName: keyof ApplicationPreferencesFormData,
    value: ApplicationPreferencesFormData[keyof ApplicationPreferencesFormData]
  ) => {
    if (fieldName !== "yearsOfExperience") {
      return; // Only handle yearsOfExperience for now
    }

    if (!isPlacementCandidate(placementCandidate)) {
      return;
    }

    const newValue = value as ApplicationPreferencesFormData["yearsOfExperience"];

    updatePlacementCandidate({
      placementCandidateId,
      workerId: worker.userId,
      yearsOfExperienceByQualification: {
        ...placementCandidate.yearsOfExperienceByQualification,
        ...newValue,
      },
    });
  };

  return (
    <WorkerPreferencesStep
      applicationQualification={applicationQualification}
      onFieldChange={handleFieldChange}
    />
  );
}
